import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardText, Form, Container, Button, Alert, Modal } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { useHistory } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import * as url from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Select from 'react-select';

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import { PROJECT_POSITIONS } from './../../helpers/url_helper';

    const AddRecruitmentRequisition = () => {
        const history = useHistory();
        const [rows1, setrows1] = useState([{ id: 1 }]);
        const [formRows, setFormRows] = useState([{ id: 1 }]);


        const onAddFormRow = () => {
            const modifiedRows = [...formRows];
            modifiedRows.push({ id: modifiedRows.length + 1 });
            setFormRows(modifiedRows);
        };

        const onDeleteFormRow = id => {
            if (id !== 1) {
            var modifiedRows = [...formRows];
            modifiedRows = modifiedRows.filter(x => x["id"] !== id);
            setFormRows(modifiedRows);
            }
        };

        const [inputs, setInputs] = useState([]);
        const [empNo, setEmpNo] = useState('');
        const [empName, setEmpName] = useState('');
        const [empTitle, setEmpTitle] = useState('');
        const [positionOptions, setPositionOptions] = useState([])
        const [positionCode, setPositionCode] = useState("")
        const [expectedStartDate, setExpectedStartDate] = useState("")
        const [numberOfPeople, setNumberOfPeople] = useState("")

        const [date, setDate] = useState('');
        const [method, setMethod] = useState('');
        const [justification, setJustification] = useState('');
        const [otherRequirements, setOtherRequirements] = useState('');
        const [recruitmentLines, setRecruitmentLines] = useState([])
    
        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);
        const [ipaSaved, setIpaSaved] = useState(false)
        const [ipaNo, setIpaNo] = useState('')

        const [modal_item, setmodal_item] = useState(false);
        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
          }
          const tog_item = () => {
            setmodal_item(!modal_item);
            removeBodyCss();
          }

        toastr.options = TOAST_OPTIONS;
  
        const handleChange = (event) => {
             const name = event.target.name;
             const value = event.target.value;
             setInputs(values => ({...values, [name]: value}));
        }
        const handleAddItem = () =>{
            const itemLine = {
                PositionCode: positionCode,
                ExpectedStartDate: expectedStartDate,
                Quantity: parseInt(numberOfPeople)
            }
            setRecruitmentLines(state =>[...state,itemLine])
            tog_item()
            setPositionCode("")
        }
        const handleRemoveItem = (key) =>{
            const newItems = [...recruitmentLines];
            newItems.splice(key, 1);
            setRecruitmentLines(newItems);
        }
        const handleSubmit = (event) => {
            setIsloading(true);
            const data = {
                "RequisitionerNo"    : empNo,
                "RecruitmentMethods" : method,
                "RequisitionDate"    : date,
                "Description"        : justification,
                "recruitmentLines"   : recruitmentLines
            }
            axios.post(url.RECRUITMENTS, data, HRConfig)
                .then(function(response){  
                    if(response.data.No){
                        toastr.success("Recruitment Requisition No "+ response.data.No+" created" ); 
                        setIpaSaved(true);
                        setIpaNo(response.data.No)
                        setIsloading(false);
                    }else{
                        toastr.success("Could not Create Recruitment Requisition" )
                        setIsloading(false);
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    setIsloading(false);
                })
                .then(function () {
                // always executed
                
            });
            
        }

        useEffect(() => {
            if (localStorage.getItem("authUser")) {
                const obj = JSON.parse(localStorage.getItem("authUser"));
                const EmployeeNo = obj.uid;
                axios.get(url.EMPLOYEES + "?$filter=No eq '"+ EmployeeNo +"'", HRConfig)
                    .then(function(response){
                        if(response.data.value.length > 0){
                            setEmpNo(response.data.value[0].No);
                            setEmpName(response.data.value[0].FirstName + " " + response.data.value[0].MiddleName+ " " + response.data.value[0].LastName);
                            setEmpTitle(response.data.value[0].JobTitle);
                            setUserError(false);
                        }else{
                            toastr.error("Employee Details Not Found in Business Central");
                        }
                    }).catch(function (error) {
                        toastr.error(error.response.data.error.message);
                        setUserError(true);
                        console.log(error);
                    })
                    .then(function () {
                    // always executed
                });
                axios.get(url.POSITIONS, HRConfig).then((r)=>{ 
                    let options = []
                    r.data.value.map((p)=>{
                        options.push({label:p.Description, value:p.No})
                    })
                    setPositionOptions(options)
                }).catch((e)=>{ console.log(e)})
    
            }
        },[]);

        
        return (
      
            <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Recruitment Requisition | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Recruitment Requisition" />
                        <div>
                        {userError && ( 
                        <Alert color="danger" role="alert">
                                    Your Employee Number Not Found in Dynamics 365 Business Central
                        </Alert>
                        )}

                        {(ipaSaved == false) ? (
                        <Row>
                        <Col xl={4}>
                        <Card>
                            <CardBody>
                            <CardTitle>Requisitioner Details</CardTitle>
                                    <Row>
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>No</label>
                                        <input type="text" className="form-control EmployeeNo" disabled={true}  value = {empNo} onChange={handleChange}  />
                                        
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>Name</label>
                                        <input  type="text" className="form-control" disabled={true} defaultValue={empName} onChange={handleChange}   />
                                        
                                        </div>
                                    </Col>
                                    </Row>
                                    <Row>
                              
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>Title</label>
                                        <input  type="text" className="form-control" disabled={true} defaultValue={empTitle} onChange={handleChange} />
                                        
                                        </div>
                                    </Col>
                                   
                                </Row>
                                
                                
                                </CardBody>
                            </Card>

                            </Col>
                            <Col  xl={8}>
                            <Card>
                            <CardBody>
                            <CardTitle>Requisition Details</CardTitle>
                                <Row>
                                <Col md={6}>
                                        <div className="mb-3">
                                        <label>Date</label>
                                        <Flatpickr
                                                    className="form-control"
                                                    onChange={(e)=>setDate(formatDate(e))}
                                                    options={{
                                                        altInput: true,
                                                        altFormat: "F j, Y",
                                                        dateFormat: "Y-m-d",
                                                        disabled: true

                                                    }}
                                                    />
                                        
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                        <label>Recruitment Method</label>
                                        <select className="form-select" value={method} onChange={(e)=>setMethod(e.target.value)}>
                                            <option value=" ">Select</option>
                                            <option value="Public">Public</option>
                                            <option value="Internal">Internal</option>
                                            <option value="Headhunting">Headhunting</option>
                                        </select>
                                        
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>Justification for Hire</label>
                                        <textarea rows={3} className="form-control" value={justification} onChange={(e)=>setJustification(e.target.value)}   />
                                        
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>Other Requirements</label>
                                        <textarea rows={3} className="form-control" value={otherRequirements} onChange={(e)=>setOtherRequirements(e.target.value)}   />
                                        
                                        </div>
                                    </Col>
                                   
            
                                   
                                    
                                    </Row>
                                    </CardBody>
                                    </Card>
                                    <div>
                                        {(recruitmentLines || []).map((r, key) => (
                                            
                                      <Card key={key}>
                                        <CardBody>
                                
                                        <CardTitle className="mb-3">
                                        Recruitment Requisition Line {key+1}
                                        </CardTitle>
                                            <Row >
                        
                                            <Col lg={4} className="mb-3">
                                            <div className="mb-3">
                                            <label> Position Code</label>
                                                <input  type="text" className="form-control" defaultValue={r.PositionCode}  />
                                                
                                            </div>
                                            </Col>
                                            <Col lg={4} className="mb-3">
                                            <div className="mb-3">
                                            <label>Expected Start Date</label>
                                                <input  type="text" className="form-control" defaultValue={r.ExpectedStartDate}  />
                                                
                                            </div>
                                            </Col>
                                           
                                            <Col lg={4} className="mb-3">
                                            <div className="mb-3">
                                            <label>Number of People</label>
                                                <input  type="text" className="form-control" defaultValue={r.Quantity}  />
                                                
                                            </div>
                                            </Col>
                                            <Col lg={1} className="align-self-center">
                                                <div className="form-floating mb-3">
                                                
                                                <input
                                                    type="button"
                                                    className="btn btn-primary"
                                                    value="Remove"
                                                    onClick={() => handleRemoveItem(key)}
                                                />
                                                </div>
                                            </Col>
                                         
                                            </Row>
                                            </CardBody>
                                            </Card>
                                            
                                        ))}
                                        <Row  className='justify-content-center'>
                                            <Col md={3}>
                                            <div className="d-grid gap-2">
                                                <input
                                                    type="button"
                                                    className="btn btn-success mt-3 mt-lg-0"
                                                    value="Add Requisition Line"
                                                    onClick={() => tog_item()}
                                                />
                                            </div>
                                          
                                            </Col>
                                            {(recruitmentLines.length > 0) && (
                                            <Col md={3}>
                                                            <div className="d-grid gap-2">
                                                                <Button color="primary" type="button" className="btn" onClick={handleSubmit}>
                                                                    Save Requisition
                                                                </Button>
                                                            </div>
                                            </Col>
                                            )}
                                            </Row>
                                            </div>

                                
                            </Col>
                            <Col>

                            <Modal
                                  isOpen={modal_item}
                                  toggle={() => {
                                    tog_item()
                                  }}
                                  centered
                                >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Add Recruitment Line</h5>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setmodal_item(false);
                                      }}
                                      className="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row >
                        
                                            
                                            <Col lg={12} className="mb-3">
                                            
                                                <label>Position Description</label>
                                                <Select options={positionOptions} onChange={(e)=>setPositionCode(e.value)}   />
                                            
                                            </Col>
                                            <Col lg={12} className="mb-3">
                                            <div className="mb-3">
                                                <label>Position Code</label>
                                                <input  type="text" className="form-control" defaultValue={positionCode} disabled={true}  />
                                                
                                            </div>
                                            </Col>
                                            <Col lg={6} className="mb-3">
                                                <div className="mb-3">
                                                <label>Expected Start Date</label>
                                                 <Flatpickr
                                                    className="form-control milestone"
                                                    placeholder="dd M,yyyy"
                                                    onChange={(e)=>setExpectedStartDate(formatDate(e))}
                                                    options={{
                                                        altInput: true,
                                                        altFormat: "F j, Y",
                                                        dateFormat: "Y-m-d",
                                                        disabled: true
                                                    }}
                                                    />
                                                
                                                </div>
                                            </Col>
                                            <Col lg={6} className="mb-3">
                                            <div className="mb-3">
                                            <label>Number of People</label>
                                                <input  type="text" className="form-control" onChange={(e)=>setNumberOfPeople(e.target.value)}   />
                                                
                                            </div>
                                            </Col>
                                           
                                         
                                            </Row>

                                  </div>
                                  <div className="modal-footer">
                                    <button
                                      type="button"
                                      onClick={() => {  tog_item() }}
                                      className="btn btn-danger "
                                      data-dismiss="modal"
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-success "
                                      onClick={()=>{handleAddItem()}}
                               
                                    >
                                      Add Item...
                                    </button>
                                  </div>
                                </Modal>
                           
                                
                               
                                            <br/>
              
                                           
                    
                        </Col>
                        </Row>
                        ):(
                            <Row className="d-flex justify-content-center">
                                <Col lg={8} >
                                <Card outline color="success" className="border">
                                    <CardBody>
                                    <CardTitle className="mb-4 text-white">
                                        
                                    </CardTitle>
                                    <CardText>
                                        
                                    </CardText>
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                                        </div>
                                        <div>
                                        <h5>Saved</h5>
                                        <p className="text-muted">
                                                Recruitment Requisition <strong>{ipaNo}</strong> Saved!
                                        </p>
                                        </div>
                                    </div>
                                    </CardBody>
                                </Card>
                                </Col>
                            </Row>
                        )}
                        </div>


                        
                           

                    </Container>
                </div>
                </LoadingOverlay>

        );
    }

export default AddRecruitmentRequisition;